import {
  GET_VIEWMODEL_REQUEST,
  GET_VIEWMODEL_SUCCESS,
  GET_VIEWMODEL_ERROR,
  SET_FILTERED_LIST,
  RESET_FILTERED_LIST,
} from "../actionTypes";
import apiService from "../../util/ApiService";

export const getViewmodel = async (dispatch, slug, startsWith) => {
  dispatch({ type: GET_VIEWMODEL_REQUEST });
  try {
    const { data } = await apiService.getViewmodel(slug, startsWith);
    dispatch({
      type: GET_VIEWMODEL_SUCCESS,
      payload: data,
    });
  } catch {
    dispatch({
      type: GET_VIEWMODEL_ERROR,
      payload: "Error fetching viewmodel",
    });
  }
};

export const setFilteredList = (dispatch, filteredList, filteredAlphaTabs) => {
  dispatch({
    type: SET_FILTERED_LIST,
    payload: { filteredList, filteredAlphaTabs },
  });
};

export const resetFilteredList = (dispatch) => {
  dispatch({ type: RESET_FILTERED_LIST });
};
